import script from "./DueDiligenceElementChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDiligenceElementChangeView.vue?vue&type=script&setup=true&lang=js"

import "./DueDiligenceElementChangeView.vue?vue&type=style&index=0&id=8a10f808&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a10f808"]])

export default __exports__